import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, viewChildren } from "@angular/core";

import { Category } from "../../../../../apis/networkdashboard/graphql/graphql";
import { FilterBar } from "../../../../common/filter-bar/filter-bar";

@Component({
  selector: "malfunction-filter-type",
  templateUrl: "malfunction-filter-type.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FilterBar, TranslatePipe],
})
export class MalfunctionFilterType {
  private filterBarChildren = viewChildren(FilterBar);

  protected plannedWork = Category.Plannedwork;
  protected malfunction = Category.Malfunction;

  reset() {
    this.filterBarChildren().forEach((fb) => fb.reset());
  }
}
